import React from 'react';
import { Link } from 'react-router-dom';
import '../styles/PutAwayList.css';

interface PutAwayItem {
    id: number;
    producto_id: number;
    nombre: string;
    cantidad_fisica: number;
    ubicacion?: {
        id: number;
        codigo: string;
        zona: string;
        pasillo: string;
        estante: string;
        nivel: string;
    };
}

interface PutAwayListProps {
    items: PutAwayItem[];
    facturaNumero: string;
}

const PutAwayList: React.FC<PutAwayListProps> = ({ items, facturaNumero }) => {
    // Agrupar ítems por ubicación lógica (ej. zona o pasillo)
    // Para simplificar, ordenamos alfabéticamente por código de ubicación
    const sortedItems = [...items].sort((a, b) => {
        const locA = a.ubicacion?.codigo || 'ZZZ';
        const locB = b.ubicacion?.codigo || 'ZZZ';
        return locA.localeCompare(locB);
    });

    const handlePrint = () => {
        window.print();
    };

    return (
        <div className="putaway-container print-container" id="put-away-list">
            <div className="putaway-header">
                <h2 className="putaway-title">Planilla de Guardado (Put-Away)</h2>
                <button
                    onClick={handlePrint}
                    className="putaway-btn-print print-hidden"
                >
                    Imprimir Planilla
                </button>
            </div>

            <p className="putaway-info-text"><strong>Factura / Recepción:</strong> {facturaNumero}</p>
            <p className="putaway-info-desc">Por favor guarde los siguientes repuestos en sus respectivas ubicaciones.</p>

            <table className="putaway-table">
                <thead>
                    <tr>
                        <th>Ubicación (Zona-Pasillo-Estante-Nivel)</th>
                        <th>Producto</th>
                        <th>Cantidad a Guardar</th>
                        <th>Check (✓)</th>
                    </tr>
                </thead>
                <tbody>
                    {sortedItems.length === 0 && (
                        <tr><td colSpan={4} className="putaway-table-empty">No hay ítems para guardar.</td></tr>
                    )}
                    {sortedItems.map((item, idx) => (
                        <tr key={idx}>
                            <td className="putaway-loc-cell">
                                {item.ubicacion ?
                                    `${item.ubicacion.zona}-${item.ubicacion.pasillo}-${item.ubicacion.estante}-${item.ubicacion.nivel}`
                                    : 'SIN UBICACIÓN (Bodega Principal)'}
                            </td>
                            <td>
                                <Link
                                    to={`/productos/${item.producto_id}`}
                                    className="pdp-link"
                                    style={{ color: '#2563eb', textDecoration: 'none', fontWeight: 'bold' }}
                                >
                                    {item.nombre}
                                </Link>
                            </td>
                            <td className="putaway-qty-cell">{item.cantidad_fisica}</td>
                            <td className="putaway-check-cell">
                                <div className="putaway-checkbox-box"></div>
                            </td>
                        </tr>
                    ))}
                </tbody>
            </table>
        </div>
    );
};

export default PutAwayList;
